import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import './Marketplace.css';

import DesignItem from './DesignItem';
import DesignItemPlaceholder from './DesignItemPlaceholder';
import InfiniteScroll from './InfiniteScroll';

import ThanksPage from './ThanksPage';
import SubmitForm from './SubmitForm';

import { actionCreators as designsCategoriesActions } from '../actions/designs-categories';

import { actionCreators as designsListActions } from '../actions/designs-list';

import uiActions from '../actions/ui';

class MarketplaceTab extends React.Component {
  state = {
    selectedCategoryId: null,
    selectedSubCategoryId: null
  };
  componentDidMount() {
    this.props.requestDesignsCategoriesLoad();
    this.props.loadSharedDesigns('all', 1);
  }

  handleCategorySelect(selectedCategoryId) {
    this.setState({ selectedCategoryId, selectedSubCategoryId: null });
    if (selectedCategoryId) {
      this.props.loadSharedDesigns(selectedCategoryId, 1);
    } else {
      this.props.loadSharedDesigns('all', 1);
    }
  }
  handleSubCategorySelect(selectedSubCategoryId) {
    this.setState({ selectedSubCategoryId });
    if (selectedSubCategoryId) {
      this.props.loadSharedDesigns(selectedSubCategoryId, 1);
    }
  }

  render() {
    const selectedCategory = _.find(
      this.props.designsCategories.items,
      item => item.id === this.state.selectedCategoryId
    );

    const hasSubCategories = _.get(
      selectedCategory,
      'relationships.subcategories.data.length'
    );

    const subCategories = hasSubCategories
      ? selectedCategory.relationships.subcategories.data.map(({ id }) =>
          _.find(this.props.children, child => child.id === id)
        )
      : [];

    const designs =
      this.props.sharedDesigns.categoryItems[
        this.state.selectedCategoryId || 'all'
      ] || [];

    const subDesigns =
      this.props.sharedDesigns.categoryItems[
        this.state.selectedSubCategoryId
      ] || [];

    const allDesigns = this.state.selectedSubCategoryId ? subDesigns : designs;
    const category =
      this.state.selectedSubCategoryId ||
      this.state.selectedCategoryId ||
      'all';

    return (
      <div className="marketplace-tab">
        <h1 className="tab-title">Choose your template</h1>
        <div className="category-list">
          <div
            className={
              'category-tab' +
              (this.state.selectedCategoryId === null ? ' active' : '')
            }
            onClick={() => {
              this.handleCategorySelect(null);
            }}
          >
            New
          </div>
          {this.props.designsCategories.items.map(category => {
            return (
              <div
                className={
                  'category-tab' +
                  (this.state.selectedCategoryId === category.id
                    ? ' active'
                    : '')
                }
                key={category.id}
                onClick={() => {
                  this.handleCategorySelect(category.id);
                }}
              >
                {category.attributes.title}
              </div>
            );
          })}
        </div>
        <div>
          {subCategories.map(category => {
            if (!category) {
              return;
            }
            return (
              <div
                className={
                  'category-child' +
                  (this.state.selectedSubCategoryId === category.id
                    ? ' active'
                    : '')
                }
                key={category.id}
                onClick={() => {
                  this.handleSubCategorySelect(category.id);
                }}
              >
                {category.attributes.title}
              </div>
            );
          })}
        </div>
        {this.props.selectDesignId && (
          <SubmitForm
            onCancel={() => {
              this.props.selectDesign(null);
            }}
          />
        )}
        {this.props.thanksShowed && <ThanksPage />}
        <div className="designs-list">
          <InfiniteScroll
            isLoading={this.props.isLoading}
            isLoadFailed={this.props.isLoadFailed}
            hasMore={this.props.hasMore}
            category={category}
            loadMore={page => {
              this.props.loadSharedDesigns(
                this.state.selectedSubCategoryId ||
                  this.state.selectedCategoryId ||
                  'all',
                page
              );
            }}
            placeholderComponent={DesignItemPlaceholder}
            items={allDesigns}
            itemRender={item => (
              <DesignItem
                key={item.id}
                design={item}
                onClick={() => {
                  this.props.selectDesign(item.id);
                }}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    selectDesignId: state.selectedDesignId,
    isLoading: state.sharedDesigns.isLoading,
    isLoadFailed: state.sharedDesigns.isLoadFailed,
    sharedDesigns: state.sharedDesigns,
    hasMore: state.sharedDesigns.hasMore,
    children: state.designsCategories.children,
    thanksShowed: state.thanksShowed,
    designsCategories: state.designsCategories
  }),
  {
    loadSharedDesigns: designsListActions.loadSharedDesigns,
    requestDesignsCategoriesLoad:
      designsCategoriesActions.requestDesignsCategoriesLoad,
    selectDesign: uiActions.selectDesign
  }
)(MarketplaceTab);



// WEBPACK FOOTER //
// ./src/components/Marketplace.js